<template>



    <el-form ref="editForm"
             :model="editForm"
             label-width="80px"
             @submit.prevent="onSubmit"
             style="margin:20px;width:60%;min-width:600px;">
        <el-form-item>
            <el-col :span="10">
                <el-select v-model="editForm.type">
                    <el-option label="短信" value="1"></el-option>
                    <el-option label="红包" value="2"></el-option>
                </el-select>
            </el-col>
        </el-form-item>

        <el-form-item label="用户">
            <el-input v-model="editForm.user"></el-input>
        </el-form-item>
        <div v-if="editForm.type=='1'">
            <el-form-item label="内容">
                <el-input v-model="editForm.content" type="text" auto-complete="off"></el-input>
            </el-form-item>
        </div>
        <div v-if="editForm.type=='2'">
            <el-form-item label="红包参数">
                <el-input v-model="editForm.tagkey" type="text" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="金额">
                <el-input v-model="editForm.price" type="text" auto-complete="off"></el-input>
            </el-form-item>
        </div>

        <el-form-item>
            <el-button @click="onSubmit" type="primary">推送</el-button>
        </el-form-item>
    </el-form>
</template>

<script>

    import { push_some } from "../../api/api";
    export default {
        data() {
            return {
                editForm: {
                    user: "",
                    content: "",
                    tagkey: "",
                    price: 0,
                    type: ""
                },
                
                show: true,
                typelist: [
                    { name: "短信", value: "1" },
                    { name: "红包", value: "2" },
                ],
                token: {
                    Authorization: "Bearer "
                },
                ruleForm: {
                    max_ver: "",
                    min_ver: "",
                    enable: ""
                },
                beforeAvatarUpload(file) {
                    const isJPG = file.type === "image/jpeg";
                    const isLt1M = file.size / 1024 / 1024 < 1;

                    // if (!isJPG) {
                    //   this.$message.error('上传头像图片只能是 JPG 格式!')
                    // }
                    if (!isLt1M) {
                        this.$message.error("上传头像图片大小不能超过 1MB!");
                    }
                    return isLt1M;
                }
            };
        },
        methods: {
            onSubmit() {
                let para = {
                    user: this.editForm.user,
                    content: this.editForm.content,
                    tagkey: this.editForm.tagkey,
                    price: this.editForm.price,
                    type: this.editForm.type
                };
                //NProgress.start();
                push_some(para).then(res => {
                    this.total = res.data.response.dataCount;
                    this.users = res.data.response.data;
                    this.listLoading = false;

                    if (res.data.success) {
                        this.$message({
                            message: "推送成功",
                            type: "success"
                        });
                    } else {
                        this.$message({
                            message: res.data.msg,
                            type: "error"
                        });
                    }


                    //NProgress.done();
                });


            },

            handleAvatarSuccess(res, file) {
                this.editForm.tdLogo = "/" + res.response;
            }
        },
        //mounted() {
        //    let tokenStr = window.localStorage.Token;
        //    this.token = {
        //        Authorization: "Bearer " + tokenStr
        //    };

        //    var user = JSON.parse(window.localStorage.user);
        //    this.editForm.uRealName = user ? user.uRealName : "";
        //}
    };
</script>

<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

        .avatar-uploader .el-upload:hover {
            border-color: #409EFF;
        }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        text-align: center;
    }

    .plus-sign {
        line-height: 120px !important;
    }

    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }

    .markdown-body {
        height: 500px !important;
    }
</style>